
export default function gatherConcepts({ state }) {

  // Prepare API request data from answers: concepts, absentList

  const { triageRequest, triageResponse } = state
  const { questions, additionalQuestions } = triageResponse
  const { answers = [], additionalAnswers = [] } = triageRequest

  // "Concept ID of answers"
  const concepts = []

  const processAnswer = a => {

    const conceptId = parseInt(a, 10)

    if (concepts.includes(conceptId)) return
    concepts.push(conceptId)
  }

  answers.forEach(processAnswer)
  additionalAnswers.forEach(processAnswer)

  // "Concept ID of answers not selected"
  const absentList = []

  const processUnanswered = ({ conceptId }) => {
    if (concepts.includes(conceptId)
      || absentList.includes(conceptId)
    ) return
    absentList.push(conceptId)
  }

  const processQuestion = q => {
    if (!q.answers || !q.answers.length) return
    q.answers.forEach(processUnanswered)
  }

  questions.forEach(processQuestion)
  additionalQuestions.forEach(processQuestion)

  return { concepts, absentList }
}
